import React, { Fragment, useState } from 'react';
import {
  ModalFooter,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
} from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import ImageGallery from '../../propinfo/gallery/index'
const UploadLiveChatAttachments = ({ visible, toggleModal, handleFiles, files, image }) => {
  const [attachementList, setAttachmentList] = useState(files || []);
  const fileObj = [];
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageAttachment, setImage] = useState();
  const { getRootProps, getInputProps } = useDropzone({
    //accept: 'image/*',
    // accept: 'image/*,font/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (!file.name.includes('exe')) {
          fileObj.push({
            img: Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          });
        }
      });
      setAttachmentList([...attachementList, ...fileObj]);
    },
  });

  const handleRemove = (index) => {
    let lst = [...attachementList];
    lst = lst.filter((f, i) => i !== index);
    setAttachmentList(lst);
    handleFiles(lst);
  };

  const handleSubmit = () => {
    handleFiles(attachementList,imageAttachment);
    toggleModal();
  };

  const togglegallery = (index) => {   
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
   setImage(image);
  };

  const ImageGalleryButton = () => {
      return (
        <Row>
          <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
            <Row>
              <Colxx xs="12" sm="3" className="mb-1">
                <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                  <ModalHeader toggle={togglegallery}>
                    Select Image or Upload New Image
                  </ModalHeader>
                  <ModalBody>
                    <ImageGallery selectedImage={selectedImage} togglegallery={togglegallery}
                      hideUserUploads={false} searchText={""} />
                  </ModalBody>
                </Modal>
              </Colxx>
            </Row>
          </Colxx>
        </Row>
      );
    };

  return (
    <Modal
      isOpen={visible}
      toggle={toggleModal}
      wrapClassName="modal-right"
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>Attachments</ModalHeader>
      <ModalBody>
        <Row className="mb-4">
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <div class="dz-default dz-message">
                <span>Drop files here to upload, or click to select files</span>
                <p className="font-weight-medium mb-0 ">
                  <i className="demo-icon simple-icon-cursor-move"></i>
                </p>
              </div>
            </div>
          </section>
        </Row>{' '}

        {attachementList.map((file, index) => (
          <Row
            className="mb-2 m-2"
            style={{ border: '1px solid', padding: '5px 10px' }}
          >
            {' '}
            <section className="container">
              <Colxx md="10">
                <div className="dz-preview dz-file-preview mb-3" key={index}>
                  <div className="row">
                    <div>
                      <span data-dz-name>{file.img.name}</span>{' '}
                    </div>
                    <div className="text-primary text-extra-small" data-dz-size>
                      {file.img.size}
                    </div>
                  </div>
                </div>
              </Colxx>
              <Colxx md="2">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handleRemove(index)}
                >
                  X
                </Button>
              </Colxx>
            </section>
          </Row>
        ))}
          {ImageGalleryButton()}
        <Fragment>
          
          <Row className="mb-3 justify-content-center">
             

    <Button
      color="primary"      
      size="sm"
      onClick={() => {
       setGalleryVisible(true);
      }}
    >
      OR Select from Image Gallery
    </Button>
  </Row>
        </Fragment>
        {imageAttachment && (<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
    <img
      style={{
        width: '125px',
        height: '125px',
        objectFit: 'cover',
        borderRadius: '8px',
        border: '1px solid #ddd',
      }}
      alt="room thumbnail"
      src={imageAttachment.src || 'https://via.placeholder.com/80'}
    />
  </div>)}

        
        
      </ModalBody>
      <ModalFooter>
        <Button color="primary" size="xs" outline onClick={handleSubmit}>
          Attach & Send
        </Button>
        <Button color="secondary" size="xs" outline onClick={toggleModal}>
          <IntlMessages id='pages.cancel' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default UploadLiveChatAttachments;
